import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
const VARIANTS = {
  PROJECTS: 'projects',
  TEMPLATES: 'templates'
};
const ProjectsError = _ref => {
  let {
    retry,
    projectsCount,
    variant
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  const translationKey = variant === VARIANTS.TEMPLATES ? 'TEMPLATES_ERROR_MESSAGE' : 'PROJECTS_ERROR_MESSAGE';
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "center",
    height: "64px",
    padding: "0 28px 0 27px"
  }, /*#__PURE__*/React.createElement(AlertWarningIcon, {
    style: {
      flexShrink: 0
    }
  }), /*#__PURE__*/React.createElement(Box, {
    paddingLeft: "8px"
  }, /*#__PURE__*/React.createElement(Text, {
    typography: "bodySmall",
    color: "charcoal700",
    paddingRight: "5px"
  }, T.translate(translationKey, {
    context: projectsCount
  })), /*#__PURE__*/React.createElement(LinkButton, {
    onClick: retry
  }, /*#__PURE__*/React.createElement(Text, {
    typography: "bodySmall"
  }, T.translate('TRY_AGAIN')))));
};
ProjectsError.displayName = 'ProjectsError';
ProjectsError.propTypes = {
  retry: PropTypes.func,
  projectsCount: PropTypes.number,
  variant: PropTypes.oneOf(Object.values(VARIANTS))
};
export default Object.assign(ProjectsError, {
  VARIANTS
});
//# sourceMappingURL=ProjectsError.js.map